import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from 'mobx-state-tree';

const initState = {};

export const Model = types
  .model({})
  .volatile((self) => {
    return {
      position: {
        x: 0,
        y: 0,
        clientX: 0,
        clientY: 0,
      },
    };
  })
  .actions((self) => {
    const setPosition = (position) => {
      self.position = position;
    };
    return {
      setPosition,
    };
  });

export default {
  initState,
  Model,
};
